import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

const defaultMaskOptions = {
    prefix: '£',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 7, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
}

export function currencyAsNumber(currencyAsString: string)
{
    if (!currencyAsString) {
        return 0
    }
    let valStr : string = currencyAsString
    if (valStr[0] === '£') {
        if (valStr.length === 1) { 
            return 0
        }       
    }
    valStr = valStr.substring(1)
    try {
        return Number(valStr)
    } 
    catch (error) {
        return 0
    }
}

export function CurrencyInput({...inputProps}) {
    const currencyMask = createNumberMask(defaultMaskOptions)
    return <MaskedInput mask={currencyMask} {...inputProps} />
}

export default CurrencyInput